import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {ComponentSelected, useAvailability} from '../composables/useAvailability';
    import {storeToRefs} from 'pinia';
    import ModifyAvailabilityDialog from './availability-dialog/ModifyAvailabilityDialog.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAvailability',
  setup(__props) {

    const availabilityStore = useAvailability();
    const {availability, label} = storeToRefs(availabilityStore);
    const {showAvailability} = availabilityStore;

    function onClick() {
        showAvailability('USER_CLICK_ON_NAVBAR', ComponentSelected.DROPDOWN);
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyAvailability = _resolveComponent("VJoyAvailability")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModifyAvailabilityDialog),
    (_unref(availability))
      ? (_openBlock(), _createBlock(_component_VJoyAvailability, {
          key: 0,
          class: "availability",
          "data-testid": "navbar-availability",
          "is-partial": _unref(availability)?.partial,
          status: _unref(availability)?.value,
          label: _unref(label),
          onClick: onClick
        }, null, 8, ["is-partial", "status", "label"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})